import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, of, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService, ExceptionHttp } from './api.service';
import { SesionService } from './sesion.service';
import { catchError } from 'rxjs/operators';
import { EgonTown } from '../models/egon-town';
import { DestinationType } from '../comun/recipient-services/DestinationType';


@Injectable()
export class EgonService extends ApiService implements OnDestroy {
  private subscriptionExpedicion: Subscription;
  disponible = true;
  private destinationType: DestinationType;
  private destination: string;
  private destinationCode: string;
  constructor(private sesion: SesionService) {
    super('');
    this.subscriptionExpedicion = this.sesion.expedition$.subscribe((e) => {
      this.disponible = true;
      this.destinationType = e.DestinationType;
      this.destination = e.Destination;
      this.destinationCode = e.DestinationCode;
    });
  }
  ngOnDestroy() {
    this.subscriptionExpedicion.unsubscribe();
  }
  localities(zipCode: string): Observable<Array<EgonTown>> {
    if (!this.disponible) {
      return of([]);
    }
    
    return this.http.get<Array<EgonTown>>(this.url('address-options'), {
      params: new HttpParams()
        .set('zipCode', zipCode)
        .set('country', this.getCountry())
        .set('destination', this.destination)
        .set('destinationCode', this.destinationCode)
    }).pipe(catchError((err, caugth) => {
      if (err.status && err.status === 503) {
        this.disponible = false;
        return of([]);
      }
      return throwError(err);
    }));
  }

  streets(location: string, localities: EgonTown[], busqueda: string): Observable<Array<string>> {
    if (!this.disponible) {
      return of([]);
    }
    if (localities.length > 0) {
      let streets =
        localities.find((item) => item.City === location)
          ?.Streets ?? [];
      if (busqueda) {
        streets = streets.filter(s => s
          .toLowerCase()
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .includes(busqueda.toLowerCase()));
      }
      return of(streets);
    }
    return of([]);
  }

  private getCountry() {
    return this.destinationType == DestinationType.España ? "ES" : "PT";
  }
}

